import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  isLoading: false,
  hasData: false,
  isError: false,
  error: "",
  loungeFindetInformation: {},
  selectedDropdownLounge: {}
};
const loungeinfoSlice = createSlice({
  name: "loungeInfo",
  initialState,
  reducers: {
    loungeInfoRequest: (state, action) => {
      state.isLoading = true;
      state.error = "";
      state.isError = false;
      state.loungeFindetInformation = {};
    },
    loungeInfoSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.loungeFindetInformation = action.payload;
      state.error = "";
      state.isError = false;
    },
    loungeInfoFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.hasData = false;
      state.isError = true;
    },
    storeLoungeDropdownInfo: (state, action) => {
      state.isLoading = false;
      state.selectedDropdownLounge = action.payload;
      state.error = "";
      state.isError = false;
    }
  }
});
export const {
  loungeInfoRequest,
  loungeInfoSuccess,
  loungeInfoFailure,
  storeLoungeDropdownInfo
} = loungeinfoSlice.actions;
export default loungeinfoSlice.reducer;